<template>
  <!-- Btn WhatsApp -->
  <a
    v-if="$vuetify.breakpoint.mobile && $permissions().btnWhatsapp"
    :href="whatsAppHref"
    target="_blank"
    style="
      background-image: url(https://dozr8la71aog.cloudfront.net/social/whatsapp_color.png);
      width: 48px;
      height: 48px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      position: fixed;
      bottom: 64px;
      z-index: 9;
      left: 8px;
    "
  ></a>
</template>
<script>
export default {
  computed: {
    whatsAppHref() {
      if (this.$domain() === "betpremier") {
        return "https://api.whatsapp.com/send?phone=5551997370145&text=Ol%C3%A1,%20vim%20atrav%C3%A9s%20do%20site%20e%20preciso%20de%20suporte";
      }

      return `https://wa.me/${this.$store.state.operators.contact_phone}`;
    },
  },
};
</script>
